import { AppConfig } from '@/utils/AppConfig';
import WithTwitter from '@/components/withTwitter';
import WithInsta from '@/components/withInsta';

interface Props {
  html: string;
  styles?: string;
}

const WysiwygBlock = ({ html, styles }: Props) => {
  AppConfig.directusBoUrls?.forEach((url) => {
    html = html.split(url).join(AppConfig.directusUrl);
  });

  html = html.replace(new RegExp('&copy; null', 'g'), '©');
  const tweet = html.match(/twitter-tweet/g);
  const insta = html.match(/data-instgrm/g);

  return (
    <>
      <div
        data-test-id='wysiwyg-block'
        dangerouslySetInnerHTML={{ __html: html }}
        className={`ffbb-wysiwyg-block ${styles}`} />
      {tweet && tweet.length > 0 && (<WithTwitter content={html} />)}
      {insta && insta.length > 0 && (<WithInsta content={html} />)}
    </>
  );
}

export default WysiwygBlock;
